import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";

const DataCtx = createContext(null);

export function DataProvider({ children, role }) {
  const [products, setProducts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [koliTypes, setKoliTypes] = useState([]);
  const [soleCards, setSoleCards] = useState([]);
  const [suppliers, setSuppliers] = useState([]);

  const refreshSuppliers = useCallback(async () => {
    const r = await api.get("/suppliers");
    setSuppliers(r.data);
  }, []);

  const refreshSoleCards = useCallback(async () => {
    const r = await api.get("/soles/cards");
    setSoleCards(r.data);
  }, []);

  const refreshKoliTypes = useCallback(async () => {
    const r = await api.get("/koli-types");
    setKoliTypes(r.data);
  }, []);

  const refreshProducts = useCallback(async () => {
    const r = await api.get("/products");
    setProducts(r.data);
  }, []);
  const refreshCustomers = useCallback(async () => {
    const r = await api.get("/customers");
    setCustomers(r.data);
  }, []);

  useEffect(() => {
    // Staff accounts may not have access to every list
    [refreshProducts, refreshKoliTypes, refreshSoleCards, refreshSuppliers, ...(role !== "cutter" ? [refreshCustomers] : [])]
      .forEach((f) => f().catch(() => {}));
  }, [refreshProducts, refreshCustomers, refreshKoliTypes, refreshSoleCards, refreshSuppliers, role]);

  const productMap = useMemo(() => new Map(products.map((p) => [p.id, p])), [products]);
  const productById = useCallback((id) => productMap.get(id), [productMap]);
  const productLabel = (p) =>
    p ? `${p.model_code} · ${p.model_color}${p.sole_code ? " · Taban " + p.sole_code : ""}${p.season ? " · " + p.season : ""}` : "—";

  return (
    <DataCtx.Provider value={{
      products, customers, koliTypes, soleCards, suppliers,
      refreshProducts, refreshCustomers, refreshKoliTypes, refreshSoleCards, refreshSuppliers,
      productById, productLabel,
    }}>
      {children}
    </DataCtx.Provider>
  );
}

export const useData = () => useContext(DataCtx);
